import Component from "@base/js/component";
import throttle from "lodash.throttle";

export default class CookieBanner extends Component {
  className = "cookie-banner";

  sessionName = "cmwf-allowed";

  handleResize = throttle(() => {
    if (sessionStorage.getItem(this.sessionName)) {
      this.updateMaxHeight(0);
    } else {
      this.updateMaxHeight(this.children.container.offsetHeight);
    }
  }, 300);

  handleAccept = () => {
    sessionStorage.setItem(this.sessionName, true);
    this.element.classList.remove(`${this.className}--visible`);
    this.element.ariaHidden = true;
    this.updateMaxHeight(0);
  };

  // Defines the element selector which will initialize this component
  static selector = ".cookie-banner";

  // Defines children that needs to be queried as part of this component
  static children = {
    button: ".cookie-banner__button",
    container: ".cookie-banner-container",
    // items: [".cookie-banner__items"] // Queries a an array of elements
  };

  // Defines sub components that needs to be queried as part of this component
  static members = {
    // subComponent: ComponentClass, // Maps as a single subcomponent instance
    // subComponents: [ComponentClass], // Maps as an array of subcomponent instances
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    button: {
      click: this.handleAccept,
    },
  };

  // constructor() {
  //   super();
  // }

  // Will be called upon component instantiation
  afterInit() {
    const isAccepted = sessionStorage.getItem(this.sessionName);

    if (!isAccepted) {
      this.element.classList.add(`${this.className}--visible`);
      this.updateMaxHeight(this.children.container.offsetHeight);
      this.element.ariaHidden = false;
    }

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }

  updateMaxHeight(maxHeight = 0) {
    document.body.style.setProperty("--cookie-banner-height", `${maxHeight}px`);
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
CookieBanner.init();
